module.exports = __webpack_public_path__ + "media/images/quote-d9726b58f9a173ce9fc06590bf666167.svg";